import { render, staticRenderFns } from "./DetailRecipe.vue?vue&type=template&id=4b78820e&scoped=true"
import script from "./DetailRecipe.vue?vue&type=script&lang=js"
export * from "./DetailRecipe.vue?vue&type=script&lang=js"
import style0 from "./DetailRecipe.vue?vue&type=style&index=0&id=4b78820e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b78820e",
  null
  
)

export default component.exports